import React from "react";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from "react-responsive-carousel";
import useBreakpoints from "../../hooks/useBreakpoints";
import {
  imgUno,
  tabletImages,
} from "../../features/QuotePage/components/CardProducts/imagesTravesiaCatedral";
import { getImageUrl } from "../../helpers/cloudinary";
const BannerCarousel = () => {
  const { isMobile } = useBreakpoints();

  const renderSlides = () => {
    if (isMobile) {
      return tabletImages.map((image, index) => (
        <div key={index}>
          <a href="/quote">
            <img
              alt="Travesía catedral"
              src={getImageUrl(image, {
                width: 800,
                quality: 80,
                format: "jpg",
                crop: "pad",
              })}
            />
          </a>
        </div>
      ));
    }
    return (
      <div>
        <a href="/quote">
          <div>
            <img
              alt="Travesía catedral"
              src={getImageUrl(imgUno, {
                width: 2000,
                quality: 80,
                format: "jpg",
                crop: "pad",
              })}
            />
          </div>
        </a>
      </div>
    );
  };

  return (
    <Carousel
      autoPlay
      infiniteLoop
      showStatus={false}
      showThumbs={false}
      interval={5000}
      transitionTime={1000}
    >
      {renderSlides()}
    </Carousel>
  );
};

export default BannerCarousel;
